var React = require('react');

function Connect0 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1000 0C1010 550 550 1000 0 1000V420.181V333.333C185.923 333.333 336.645 184.094 336.645 0H1000V0Z","fill":"currentColor"}));
}

Connect0.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000","fill":"none"};

module.exports = Connect0;

Connect0.default = Connect0;
